<template>
  <div
    class="astrology-horoscope-card p-3.5 rounded-lg h-[217px] w-[164px]"
    :class="isDark ? 'bg-[#181819] border-2 border-[#d0d9ff66]' : 'bg-[#F7F2DA]'"
  >
    <div class="astrology-horoscope-card-image">
      <OImage :src="img" :alt="horoscope.title" />
    </div>
    <div v-if="showInfo" class="astrology-horoscope-card-info">
      TODO: Horoscope info
      <!-- <h3 class="text-lg font-bold">{{ horoscope.title }}</h3>
            <p class="text-sm">{{ info }}</p> -->
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import OImage from '~/modules/common/components/ui/OImage/OImage.vue';

export default defineComponent({
  components: {
    OImage,
  },
  props: {
    horoscope: Object,
    showInfo: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['mouseenter', 'mouseleave'],
  setup(props) {
    const getDarkImage = (name) => {
      return `/images/astrology/burclar/dark/${name}.png`;
    };
    const getLightImage = (name) => {
      return `/images/astrology/burclar/light/${name}.png`;
    };
    const img = computed(() => (props.isDark ? getDarkImage(props.horoscope.image) : getLightImage(props.horoscope.image)));
    return {
      getDarkImage,
      getLightImage,
      img,
    };
  },
});
</script>

<style scoped>
.astrology-horoscope-card {
  cursor: pointer;
}
</style>
